import { render, staticRenderFns } from "./titleManagement.vue?vue&type=template&id=21d8e5a4&scoped=true"
import script from "./titleManagement.vue?vue&type=script&lang=js"
export * from "./titleManagement.vue?vue&type=script&lang=js"
import style0 from "./titleManagement.vue?vue&type=style&index=0&id=21d8e5a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21d8e5a4",
  null
  
)

export default component.exports